module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-text@2x-e29fd55ab35cde301c4d6600afd85e5e.png";